// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"5c4c8727","105":"f7b8c9bb","643":"520f2149","758":"bd55a030"}[chunkId] + ".chunk.js";
};